import { AtualizarObservacaoAuditoriaContaFinanceiraModel } from "../models/auditoriaContaFinanceira/atualizarObservacaoAuditoriaContaFinanceiraModel";
import { AuditoriaContaFinanceiraDTOModel } from "../models/auditoriaContaFinanceira/auditoriaContaFinanceiraDTOModel";
import { BuscaAuditoriaContaFinanceiraModel } from "../models/auditoriaContaFinanceira/buscaAuditoriaContaFinanceiraModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toastError, toastSucess } from "../util/toast";
import { setModalObservacaoAuditoriaContaFinanceira, setPageAuditoriaContaFinanceira } from "../redux/slices/auditoriaContaFinanceira/auditoriaContaFinanceiraSlice";

export const cadastrarAuditoriaContaFinanceira = createAsyncThunk("/AuditoriaContaFinanceira/CadastrarAuditoriaContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/AuditoriaContaFinanceira/CadastrarAuditoriaContaFinanceira", payload.value);
    toastSucess("Auditoria das contas financeiras realizadas com sucesso");
    dispatch(setPageAuditoriaContaFinanceira("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarAuditoriaContaFinanceira = createAsyncThunk("/AuditoriaContaFinanceira/BuscarAuditoriaContaFinanceira", async (args: BuscaAuditoriaContaFinanceiraModel) => {
  try {
    const data = await api.post("/AuditoriaContaFinanceira/BuscarAuditoriaContaFinanceira", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarHistoricoAuditoriaContaFinanceira = createAsyncThunk("/AuditoriaContaFinanceira/ListarHistoricoAuditoriaContaFinanceira", async (idContaFinanceira: number) => {
  try {
    const data = await api.get("/AuditoriaContaFinanceira/ListarHistoricoAuditoriaContaFinanceira", { params: { idContaFinanceira: idContaFinanceira } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarObservacaoAuditoriaContaFinanceira = createAsyncThunk("/AuditoriaContaFinanceira/AtualizarObservacaoAuditoriaContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/AuditoriaContaFinanceira/AtualizarObservacaoAuditoriaContaFinanceira", null, { params: payload.value });
    toastSucess("Motivo da auditoria de Conta Financeira atualizada com sucesso");
    dispatch(setModalObservacaoAuditoriaContaFinanceira(false));
    dispatch(setLoading(false));

    dispatch(buscarAuditoriaContaFinanceira(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
